// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import {enableAutomaticPageViews, initialAnalytics} from '../lib/analytics';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';

import styles from './index.css';

initialAnalytics();
enableAutomaticPageViews();

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

if (supportedBrowser()) {
    const pathname = window.location?.pathname || '';
    const normalizedPath = pathname.toLowerCase();

    if (normalizedPath.startsWith('/reset-password/')) {
        const token = decodeURIComponent(pathname.substring('/app/reset-password/'.length))
            .replace(/^\/+/, '')
            .replace(/\/+$/, '');

        import('../components/login/ResetPasswordPage.jsx').then(mod => {
            const ResetPasswordPage = mod.default;
            ReactDOM.render(<ResetPasswordPage token={token} />, appTarget);
        });
    } else if (normalizedPath === '/about' || normalizedPath.startsWith('/about/')) {
        appTarget.className = '';
        import('../components/about/AboutPage.jsx').then(mod => {
            const AboutPage = mod.default;
            ReactDOM.render(<AboutPage />, appTarget);
        });
    } else if (normalizedPath.startsWith('/dashboard')) {
        import('../dashboard/DashboardApp.jsx').then(mod => {
            const DashboardApp = mod.default;
            ReactDOM.render(<DashboardApp />, appTarget);
        });
    } else {
        // require needed here to avoid importing unsupported browser-crashing code
        // at the top level
        require('./render-gui.jsx').default(appTarget);
    }
} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => {};
    // eslint-disable-next-line react/jsx-no-bind
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
}
